import React, { useState } from 'react';
import Select from 'react-select';
import AddProject from './AddProject';
import AddTask from './AddTask';

const AddTimeLog = ({ isOpen, setIsOpen }) => {
    const [timeInputType, setTimeInputType] = useState('duration'); // 'duration' or 'startEnd'
    const [isAddProjectModalOpen, setAddProjectModalOpen] = useState(false);
    const [isAddTaskModalOpen, SetAddTaskModalOpen] = useState(false);
    const [selectedTasks, setSelectedTasks] = useState([]);

    if (!isOpen) return null;

    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
    ];

    const projectOptions = [
        { value: 'project1', label: 'Project 1' },
        { value: 'project2', label: 'Project 2' },
    ];

    const taskOptions = [
        { value: 'task1', label: 'Task 1' },
        { value: 'task2', label: 'Task 2' },
    ];

    const staffOptions = [
        { value: 'staff1', label: 'Staff 1' },
        { value: 'staff2', label: 'Staff 2' },
    ];

    return (
        <>

            <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
                <div
                    className="custom-modal-content"
                    onClick={(e) => e.stopPropagation()} // Prevent closing on content click
                >
                    <h2 className="oms-modal-title">Time log details</h2>
                    <form className="oms-modal-form">
                        {/* Date Field */}
                        <div className="oms-form-group">
                            <label htmlFor="date" className="oms-form-label">
                                Date
                            </label>
                            <input type="date" id="date" />
                        </div>

                        {/* Project Name */}
                        <div className="oms-form-group">
                            <label htmlFor="project" className="oms-form-label">
                                Project
                            </label>
                            <div className="oms-flex-group">
                                <Select options={projectOptions} placeholder="Select project" />
                                <button type="button" className="oms-add-button" onClick={() => setAddProjectModalOpen(true)}>
                                    Add project
                                </button>
                            </div>
                        </div>

                        {/* Task */}
                        <div className="oms-form-group">
                            <label htmlFor="task" className="oms-form-label">
                                Task
                            </label>
                            <div className="oms-flex-group">
                                <Select
                                    options={taskOptions}
                                    placeholder="Select task"
                                    isMulti
                                    onChange={(selected) => setSelectedTasks(selected)}
                                />
                                <button type="button" className="oms-add-button" onClick={() => SetAddTaskModalOpen(true)}>
                                    Add Task
                                </button>
                            </div>
                        </div>

                        {/* Time Spent */}
                        <div className="oms-form-group">
                            <div className="label-toggle">
                                <label className="oms-form-label">Time Spent</label>
                                <button
                                    type="button"
                                    className="oms-toggle-button"
                                    onClick={() =>
                                        setTimeInputType((prev) =>
                                            prev === 'duration' ? 'startEnd' : 'duration'
                                        )
                                    }
                                >
                                    {timeInputType === 'duration' ? 'Switch to Start & End Time' : 'Switch to Duration'}
                                </button>
                            </div>
                            {timeInputType === 'duration' ? (
                                <div>
                                    <label htmlFor="duration" className="oms-time-label">
                                        Duration
                                    </label>
                                    <input type="time" id="duration" placeholder="Enter time duration" />
                                </div>
                            ) : (
                                <div className="oms-time-range">
                                    <div className="oms-time-range-list">
                                        <label htmlFor="start-time" className="oms-time-label">
                                            Start Time
                                        </label>
                                        <input type="time" id="start-time" placeholder="Start time" />
                                    </div>
                                    <div className="oms-time-range-list">
                                        <label htmlFor="end-time" className="oms-time-label">
                                            End Time
                                        </label>
                                        <input type="time" id="end-time" placeholder="End time" />
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Notes */}
                        <div className="oms-form-group">
                            <label htmlFor="notes" className="oms-form-label">
                                Notes
                            </label>
                            <textarea id="notes" placeholder="Enter notes" rows="4" />
                        </div>

                        {/* Staff Selection */}
                        <div className="oms-form-group">
                            <label htmlFor="staff" className="oms-form-label">
                                Staff
                            </label>
                            <Select options={staffOptions} placeholder="Select staff" />
                        </div>

                        {/* Actions */}
                        <div className="oms-form-actions">
                            <button type="button" onClick={() => setIsOpen(false)}>
                                Cancel
                            </button>
                            <button type="submit">Submit</button>
                        </div>
                    </form>
                </div>
            </div>


            <AddProject isOpen={isAddProjectModalOpen} setIsOpen={setAddProjectModalOpen} />
            <AddTask isOpen={isAddTaskModalOpen} setIsOpen={SetAddTaskModalOpen} />
        </>
    );
};

export default AddTimeLog;
